export default "__VITE_ASSET__DMYtSItb__";